import TermsOfUseContent from "./terms-of-use-content";

export default TermsOfUseContent;
